import { SGPlugin } from '../common/SGPlugins'
import { captureException } from '../common/helpers'

export default (elements: NodeListOf<HTMLElement>) => {
  elements.forEach((element) => {
    const plugins = (element.getAttribute('data-plugins') ?? '').split(' ')
    if (plugins.includes('sg-dropdown')) {
      plugins.splice(plugins.indexOf('sg-dropdown'), 1)
    }
    element.setAttribute('data-plugins', plugins.join(' '))
    const options = SGPlugin.getElementOptions<{
      target: string,
      template?: string,
      targetClass: string,
      selfClass?: string
    }>(element, 'sg-dropdown', true, {
      'target-class': 'targetClass',
      'self-class': 'selfClass'
    })
    if (!options.target || !options.targetClass) {
      return
    }
    element.addEventListener('click', () => {
      const target = document.querySelector(options.target)
      if (!target) {
        captureException('Dropdown', new Error('Dropdown plugin target not found'))
        return
      }
      if (options.template && target.innerHTML === '') {
        const template = document.querySelector<HTMLElement>(options.template)
        if (template instanceof HTMLTemplateElement) {
          target.innerHTML = ''
          target.appendChild(template.content.cloneNode(true))
        } else {
          target.innerHTML = template.innerHTML
        }
      }
      target.classList.toggle(options.targetClass)
      if (options.selfClass) {
        element.classList.toggle(options.selfClass)
      }
    })
  })
}
